import React from 'react';
import UnauthorizedView from './components/UnauthorizedView';
import { useAccessCheck } from './hooks/useAccessCheck';

const Unauthorized = () => {
  const { loading, error, countdown } = useAccessCheck();

  return (
    <UnauthorizedView 
      loading={loading}
      error={error} 
      countdown={countdown} 
    />
  );
};

export default Unauthorized;
